// extracted by mini-css-extract-plugin
export var aboveFoldDescription = "AboutPage-module--above-fold-description--S85mX";
export var aboveTheFold = "AboutPage-module--above-the-fold--V0-Xg";
export var description = "AboutPage-module--description--AYtO1";
export var fadeIn = "AboutPage-module--fade-in--Ia7J-";
export var heading = "AboutPage-module--heading--Fkkk+";
export var image = "AboutPage-module--image--dfKXL";
export var subHeading = "AboutPage-module--sub-heading--Ljm0w";
export var title = "AboutPage-module--title--0js-f";
export var titleSection = "AboutPage-module--title-section--eCMR7";